module.exports = __webpack_public_path__ + "img/search-empty.9947094b.png";